import React from "react";
import { useState, useEffect } from "react";
import Navbar from "../../components/NavBar/Navbar";
import Footer from "../../components/Footer/Footer";
import faqimg from "../../images/FAQ/faq.svg";
import headerdesign from "../../images/header design.svg";
import { Data } from "./Data";
import ScrollTop from "../../components/ScrollToTop/ScrollTop";
import "./faqs.css";
import CreateWhatsappChatWidget from "../../components/WhatsAppIcon";

export default function Faqs() {
  const listenScrollEvent = () => {
    window.scrollY > 100
      ? (document.getElementById("return-to-top").style.display = "grid")
      : // setnavColor("#252734")
        (document.getElementById("return-to-top").style.display = "none");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  const [clicked, setClicked] = useState(false);

  const toggle = (index) => {
    if (clicked === index) {
      return setClicked(null);
    }

    setClicked(index);
  };

  var url =
    "https://wati-integration-service.clare.ai/ShopifyWidget/shopifyWidget.js?3023";
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = url;
  var options = {
    enabled: true,
    chatButtonSetting: {
      backgroundColor: "#4dc247",
      ctaText: "",
      borderRadius: "25",
      marginLeft: "0",
      marginBottom: "50",
      marginRight: "50",
      position: "right",
    },
    brandSetting: {
      brandName: "SKYLARK",
      brandSubTitle: "Typically replies within a day",
      brandImg:
        "https://skylark-website-images.s3.ap-south-1.amazonaws.com/logo_res.png",
      welcomeText: "Hi there!\nHow can I help you?",
      messageText:
        "Hello team SKYLARK, I have an upcoming event.\nWhen can we schedule a meeting to discuss the details and requirements?",
      backgroundColor: "#8e0405",
      ctaText: "Start Chat",
      borderRadius: "25",
      autoShow: false,
      phoneNumber: "916201811075",
    },
  };
  s.onload = function () {
    CreateWhatsappChatWidget(options);
  };
  var x = document.getElementsByTagName("script")[0];
  x.parentNode.insertBefore(s, x);

  return (
    <div className="page_container">
      <div className="faq_page_header">
        <Navbar />

        <div className="pages_header_content" style={{ maxWidth: "90%" }}>
          <p className="faq_header_text">Frequently Asked Questions</p>

          <img className="header_design" src={headerdesign} />
        </div>
      </div>
      <ScrollTop />
      <div className="faqs_page_cont">
        <div className="faq_page_image">
          <div className="faq_faqs">
            {Data.map((item, index) => {
              return (
                <>
                  <div
                    className="Wrap open"
                    onClick={() => toggle(index)}
                    key={index}
                  >
                    <span>
                      {clicked === index ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="minus"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M18 12H6"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="plus"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                          />
                        </svg>
                      )}
                    </span>

                    {clicked === index ? (
                      <h1 className="s1">{item.question}</h1>
                    ) : (
                      <h1 className="s2">{item.question}</h1>
                    )}
                  </div>
                  {clicked === index ? (
                    <div className="Dropdown">
                      <p>{item.answer}</p>
                    </div>
                  ) : null}
                </>
              );
            })}
          </div>

          <div className="faq_page_bottom">
            <img src={faqimg} className="faq_img" alt="faq_image" />
            {/* <Query /> */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
